import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      marginTop: 14,
    },
  },
  text: {
    color: '#54565B',
    lineHeight: '20px',
    width: 895,
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      lineHeight: '18px',
      marginBottom: 0,
    },
  },
}));
